import { Action, MiddlewareAPI } from '@reduxjs/toolkit'
import { ThunkAction } from 'redux-thunk'
import { isFunction } from 'lodash'
import { Store } from 'redux'

import { RootState } from '../reducers'

export type GetState = () => RootState

interface PossiblyRealtimeAction extends Action<string> {
  isRealtime?: boolean
  payload?: any
}

export type FeedbotThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  undefined,
  PossiblyRealtimeAction
>

export type FeedbotAction = PossiblyRealtimeAction | FeedbotThunk

export type FeedbotDispatch = {
  <A extends PossiblyRealtimeAction>(action: A): A
  <A extends FeedbotThunk>(thunk: A): ReturnType<A>
}

export type FeedbotMiddleware = (
  api: MiddlewareAPI<FeedbotDispatch, RootState>
) => (next: FeedbotDispatch) => (action: FeedbotAction) => FeedbotAction | void

export type StoreApi = { dispatch: FeedbotDispatch; getState: () => RootState }

// @ts-ignore
export type FeedbotStore = Store<RootState, FeedbotAction>

export const isThunk = (action: FeedbotAction): action is FeedbotThunk => {
  return isFunction(action)
}
